import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-authenticators.manage.edit', {
        url: '/edit',
		component: 'companySharingCenterSharedAuthenticatorsManage',
		
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.state.js